"use client";

import RSS1 from "@/assets/frau-auto-profil-erstellen.avif";
import RSS3 from "@/assets/frau-auto-fahrer-unterwegs.avif";
import RSS2 from "@/assets/frau-auto-hoechstgebot-20500.avif";
import Step1 from "@/assets/svgs/Step1.svg";
import Step2 from "@/assets/svgs/Step2.svg";
import Step3 from "@/assets/svgs/Step3.svg";
import Underline from "../../../components/Underline/Underline";
import Image from "next/image";

// Lighthouse saw these images rendered ~364px wide on mobile; using a fixed mobile size
// prevents Next from generating/serving unnecessarily large variants (e.g. 750w).
const RSS_SIZES = "(max-width: 768px) 364px, 728px";
const STEP_SIZES = "(max-width: 768px) 16vw, 64px";

export const ReadySetSold = () => {
  return (
    <section className="ReadySetSold">
      <div className="RSS-wrapper">
        <h2 className="section-title">
          Einfach. Schnell.&nbsp;
          <Underline text="Verkauft." />
        </h2>

        <p className="section-subtitle">
          Verkaufe dein Auto zum Bestpreis – in drei einfachen Schritten
        </p>

        <div className="RSS-image-container">
          <div className="RSS-image-wrapper">
            <Image
              src={RSS1}
              alt="Autoeinfachlos - Auto einfach online verkaufen"
              className="RSS-image"
              // 🔽 realistischer Max-Size statt 2500x2500
              width={728}
              height={728}
              sizes={RSS_SIZES}
            />

            <div className="RSS-Header-wrapper">
              <Image
                src={Step1}
                alt="Autoeinfachlos - Auto einfach online verkaufen"
                className="Step-image"
                width={64}
                height={64}
                sizes={STEP_SIZES}
              />

              <h3>Profil erstellen</h3>
            </div>
            <p>
              Fahrzeuginformationen und Bilder hinzufügen, Profil abschließen
              und direkt in die Auktion starten
            </p>
          </div>

          <div className="RSS-image-wrapper">
            <Image
              src={RSS2}
              alt="Autoeinfachlos - Auto einfach online verkaufen"
              className="RSS-image"
              width={728}
              height={728}
              sizes={RSS_SIZES}
            />

            <div className="RSS-Header-wrapper">
              <Image
                src={Step2}
                alt="Autoeinfachlos - Auto einfach online verkaufen"
                className="Step-image"
                width={64}
                height={64}
                sizes={STEP_SIZES}
              />
              <h3>Bestes Angebot sichern</h3>
            </div>

            <p>
              Über 5.000 Händler konkurrieren in einer Online-Auktion um dein
              Auto. Wir übermitteln dir das beste Angebot
            </p>
          </div>

          <div className="RSS-image-wrapper">
            <Image
              src={RSS3}
              alt="Autoeinfachlos - Auto einfach online verkaufen"
              className="RSS-image"
              width={728}
              height={728}
              sizes={RSS_SIZES}
            />

            <div className="RSS-Header-wrapper">
              <Image
                src={Step3}
                alt="Autoeinfachlos - Auto einfach online verkaufen"
                className="Step-image"
                width={64}
                height={64}
                sizes={STEP_SIZES}
              />
              <h3>Verkauf abschließen</h3>
            </div>

            <p>
              Verkauf in 24 Stunden abschließen – mit Abholung und sofortiger
              Bezahlung, komplett kostenlos
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
